import { Button, Form, Row, Col } from 'react-bootstrap'
import '../css/client/editclient.css'
import { MdClose, MdSave, MdEdit, MdCheckCircle, MdPauseCircleFilled, MdCancel, MdAccessTime, MdInfo, MdPersonOutline, MdPanTool } from 'react-icons/md';
import { useCallback, useContext, useEffect, useState } from 'react'
import api from '../../api'
import { auth } from "../../firebase"
import SimpleBar from 'simplebar-react';
import 'simplebar-react/dist/simplebar.min.css';
import Swal from 'sweetalert2'
import { Dimcontext } from '../../context/pagecontext'
import { ToastContainer } from 'react-toastify'
import { Datacontext } from '../../context/dataContext'
import { useNavigate } from "react-router-dom";
import { AuthContext } from '../../context/authContext'

// IMPORT THE MODAL (Adjust the path to wherever you saved the file)
import ApproveClientModal from './approve'; 

export const EditAppClient = ({ set_edit, id, showToast }) => {
    const navigate = useNavigate()
    const { user } = useContext(AuthContext);
    const { setDim } = useContext(Dimcontext);
    
    const { fetchAppClients, appClients, clients, fetchClients, fetchcountclient } = useContext(Datacontext);
    
    const [editAppClient, set_editAppClient] = useState({
        uid: "", 
        name: "", 
        email: "", 
        phoneNumber: "", 
        gender: "", 
        address: "", 
        city: "", 
        state: "",
        consentAcceptedAt: null,
        provider: "",
        profileCompleted: false,
        status: "pending",
        approved_time: null,
        approved_by: null,
        createdAt: null,
        cid: null // Added CID to initial state
    });
    
    const [hasPhone, setHasPhone] = useState('yes')
    const [options, set_options] = useState([]);

    // NEW: State to control form editability (Read-Only by default)
    const [isEditing, setIsEditing] = useState(false);

    // NEW: State to control the Approve Modal visibility
    const [isApproveModalOpen, setIsApproveModalOpen] = useState(false);

    const getStatusDisplay = (status) => {
        switch (status?.toLowerCase()) {
            case 'approved':
                return { icon: <MdCheckCircle size={18} color="#00C896" />, color: "#00C896" }; 
            case 'rejected':
                return { icon: <MdCancel size={18} color="#dc3545" />, color: "#dc3545" }; 
            case 'hold':
                return { icon: <MdPanTool size={18} color="#ffc107" />, color: "#ffc107" }; 
            case 'pending':
            default:
                return { icon: <MdInfo size={18} className="text-muted" />, color: "#495057" }; 
        }
    };

    const get_customer = useCallback(() => {
        if (clients) {
            set_options(clients.map(v => ({ 
                value: v, 
                label: `${v.name?.toUpperCase()} - ${v.nick_name || ""} - ${v.mobile}` 
            })));
        }
    }, [clients]);

    useEffect(() => {
        const editOneAppClient = () => {
            const data = (appClients || []).find(item => item.id === id);
            if (data) {
                set_editAppClient(data);
                setHasPhone((data.phoneNumber && data.phoneNumber.trim() !== "") ? 'yes' : 'no');
            }
        };
        editOneAppClient()
        get_customer()
    }, [id, appClients, get_customer])

    const formatDate = (dateObj) => {
        if (!dateObj) return "N/A";
        if (dateObj._seconds) {
            return new Date(dateObj._seconds * 1000).toLocaleString();
        }
        if (typeof dateObj === 'string' || typeof dateObj === 'number') {
            return new Date(dateObj).toLocaleString();
        }
        return "N/A";
    };

    const isStatusFinalized = editAppClient.status && editAppClient.status !== 'pending';
    
    // Logic: Disable buttons if finalized, UNLESS it's an admin who has clicked "Edit"
    const disableActions = isStatusFinalized && (user.role !== 'admin' || !isEditing);

    const handleEditAndClose = async (e) => {
        if (e) e.preventDefault();
        
        if (!/^[A-Za-z ]{2,50}$/.test(editAppClient.name)) return showToast("INVALID NAME FORMAT");
        if (editAppClient.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(editAppClient.email)) {
            return showToast("INVALID EMAIL FORMAT");
        }
        if (hasPhone === 'yes') {
            if (!editAppClient.phoneNumber || String(editAppClient.phoneNumber).length !== 10) {
                return showToast("PHONE NUMBER MUST BE 10 DIGITS");
            }
        }

        const payload = { ...editAppClient };
        if (hasPhone === 'no') {
            payload.phoneNumber = "";
        }

        try {
            const up = await api.patch(`/update_app/${id}`, payload)
            if(fetchAppClients) fetchAppClients();
            
            Swal.fire({
                title: "Updated!",
                text: up?.data?.message || "App User Updated Successfully",
                icon: "success",
                confirmButtonColor: "#00C896"
            });
            handleEditClose() // Closes the modal after successful save
        } catch (err) {
             console.error(err); 
            if (err.response && err.response.status === 401) {
                showToast("Session expired. Attempting to refresh...");
                try {
                    const freshToken = await auth.currentUser.getIdToken(true);
                    sessionStorage.setItem("token", freshToken);
                } catch (refreshErr) {
                    showToast("Refresh failed. Logging out.");
                    navigate("/")            
                }
            } else {
                showToast(err.response?.data?.message || "Something went wrong. Please try again.");
            }
        }
    }

    const fullHistoryLog = [
        { status: 'pending', at: editAppClient.createdAt, by: 'System (Creation)' },
        ...(editAppClient.actions || [])
    ].reverse();

    const handleStatusChange = (newStatus) => {
        if (newStatus !== "rejected" && newStatus !== "hold") {
            console.warn("handleStatusChange is only for Reject and Hold actions.");
            return;
        }

        const isReject = newStatus === "rejected";
        const actionColor = isReject ? "#dc3545" : "#ffc107"; 
        const actionTitle = isReject ? "Reject" : "Hold";

        Swal.fire({
            title: `Are you sure you want to ${actionTitle} this user?`,
            text: `This action will update the user's status to ${newStatus}.`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: actionColor,
            cancelButtonColor: "#6c757d",
            confirmButtonText: `Yes, ${actionTitle}!`,
            cancelButtonText: "Cancel"
        }).then(async (result) => {
            if (result.isConfirmed) {
                const adminName = user?.name || user?.email || "Admin";
                const currentTime = new Date().toISOString();

                const newActionLog = {
                    status: newStatus,
                    by: adminName,
                    at: currentTime
                };

                const updatedClient = { 
                    ...editAppClient, 
                    status: newStatus,
                    approved_by: adminName,
                    approved_time: currentTime,
                    actions: [...(editAppClient.actions || []), newActionLog] 
                };

                set_editAppClient(updatedClient);

                try {
                    await api.patch(`/update_app/${id}`, updatedClient);
                    if (fetchAppClients) fetchAppClients(); 
                    
                    Swal.fire({
                        title: "Status Updated!",
                        text: `User has been marked as ${newStatus}.`,
                        icon: "success",
                        confirmButtonColor: actionColor 
                    });
                    handleEditClose(); 
                } catch (err) {
                    console.error("Status Update Error:", err);
                    showToast("Failed to update status. Try again.");
                }
            }
        });
    };

    // Opens the custom React Modal
    const handleApprove = () => {
        setIsApproveModalOpen(true);
    };

    // Triggered by the React Modal when "Confirm & Approve" is clicked
    const executeApproval = async (updatedClientData) => {
        try {
            await api.patch(`/update_app_aprv/${id}`, updatedClientData);
            if (fetchAppClients) fetchAppClients(); 
            
            setIsApproveModalOpen(false); // Close Modal
            
            Swal.fire({
                title: "Approved!",
                text: "User has been approved successfully.",
                icon: "success",
                confirmButtonColor: "#00C896" 
            });
            fetchClients()
            fetchcountclient()
            handleEditClose(); // Close the main Edit Modal

        } catch (err) {
            console.error("Approve Error:", err);
            showToast("Failed to approve. Try again.");
        }
    };

    const handleEditClose = () => {
        set_edit(false)
        setDim(false)
    }

    return (
        <div className="edit-modal-container">
            <ToastContainer/>
            <div className='edit-modal-header'>
                <div className="d-flex align-items-center gap-2">
                    <div className="edit-brand-icon"><MdEdit /></div>
                    <h3 className='m-0'>Edit App User</h3>
                </div>
                <button type="button" onClick={handleEditClose} className='modal-close-btn'><MdClose /></button>
            </div>

            <SimpleBar style={{ maxHeight: 'calc(90vh - 130px)' }}>
                <Form className="edit-modal-body" onSubmit={handleEditAndClose}>
                    <Row className="g-3 p-4">
                        
                        {/* Notice the disabled={!isEditing} on fields */}
                        <Col md={6}>
                            <Form.Label className="edit-label">Full Name</Form.Label>
                            <Form.Control 
                                required
                                value={editAppClient.name || ''} 
                                disabled={!isEditing}
                                onChange={(e) => set_editAppClient({ ...editAppClient, name: e.target.value })} 
                            />
                        </Col>

                        <Col md={6}>
                            <Form.Label className="edit-label">Email Address</Form.Label>
                            <Form.Control 
                                value={editAppClient.email || ''}
                                disabled // Always disabled
                                style={{ cursor: "not-allowed" }}
                            />
                        </Col>

                        <Col md={6}>
                            <Form.Label className="edit-label">Gender</Form.Label>
                            <div className="gender-radio-group mt-1">
                                <Form.Check inline type="radio" label="Male" name="gender" value="male" disabled={!isEditing} checked={editAppClient.gender === 'male'} onChange={(e) => set_editAppClient({ ...editAppClient, gender: e.target.value })} />
                                <Form.Check inline type="radio" label="Female" name="gender" value="female" disabled={!isEditing} checked={editAppClient.gender === 'female'} onChange={(e) => set_editAppClient({ ...editAppClient, gender: e.target.value })} />
                            </div>
                        </Col>

                        <Col md={6}>
                            <Form.Label className="edit-label">Source</Form.Label>
                            <Form.Control className="text-capitalize" value={editAppClient.provider || 'N/A'}
                            style={{ cursor: "not-allowed" }} disabled />
                        </Col>

                        <Col md={6}>
                            <Form.Label className="edit-label">Has Phone Number?</Form.Label>
                            <div className="gender-radio-group mt-1">
                                <Form.Check inline type="radio" label="Yes" name="hasPhone" value="yes" disabled={!isEditing} checked={hasPhone === 'yes'} onChange={(e) => setHasPhone(e.target.value)} />
                                <Form.Check inline type="radio" label="No" name="hasPhone" value="no" disabled={!isEditing} checked={hasPhone === 'no'} onChange={(e) => setHasPhone(e.target.value)} />
                            </div>
                        </Col>

                        {hasPhone === 'yes' && (
                            <Col md={6}>
                                <Form.Label className="edit-label">Phone Number</Form.Label>
                                <Form.Control 
                                    type="text" maxLength={10} required
                                    value={editAppClient.phoneNumber || ''} 
                                    disabled={!isEditing}
                                    pattern="[0-9]{10}"
                                    onChange={(e) => set_editAppClient({ ...editAppClient, phoneNumber: e.target.value.replace(/\D/g, "") })} 
                                />
                            </Col>
                        )}

                        <Col xs={12}>
                            <Form.Label className="edit-label">Residential Address</Form.Label>
                            <Form.Control 
                                as="textarea" rows={2} 
                                disabled={!isEditing}
                                value={editAppClient.address || ''} 
                                onChange={(e) => set_editAppClient({ ...editAppClient, address: e.target.value })} 
                            />
                        </Col>

                        <Col md={6}>
                            <Form.Label className="edit-label">City / District</Form.Label>
                            <Form.Control
                                value={editAppClient.city || ''}
                                disabled={!isEditing}
                                placeholder="Enter city"
                                onChange={(e) => set_editAppClient({ ...editAppClient, city: e.target.value })}
                            />
                        </Col>

                        <Col md={6}>
                            <Form.Label className="edit-label">State</Form.Label>
                            <Form.Control
                                value={editAppClient.state || ''}
                                disabled={!isEditing}
                                placeholder="Enter state"
                                onChange={(e) => set_editAppClient({ ...editAppClient, state: e.target.value })}
                            />
                        </Col>

                        <Col md={6}>
                            <Form.Label className="edit-label">Pincode</Form.Label>
                            <Form.Control
                                value={editAppClient.pincode || ''}
                                disabled={!isEditing}
                                placeholder="Enter Pincode"
                                onChange={(e) => set_editAppClient({ ...editAppClient, pincode: e.target.value })}
                            />
                        </Col>

                        <Col md={6} className="d-flex flex-column justify-content-center">
                            <span className="text-muted" style={{ fontSize: "13px", fontWeight: "600" }}>
                                Created At
                            </span>
                            <span className="d-flex align-items-center gap-1 fw-bold mt-1" style={{ fontSize: "15px", color: "#495057" }}>
                                <MdAccessTime size={18} className="text-muted" />
                                {formatDate(editAppClient.createdAt)}
                            </span>
                        </Col>

                        <Col md={6} className="d-flex flex-column justify-content-center">
                            <span className="text-muted" style={{ fontSize: "13px", fontWeight: "600" }}>
                                Consent Accepted At
                            </span>
                            <span className="d-flex align-items-center gap-1 fw-bold mt-1" style={{ fontSize: "15px", color: "#495057" }}>
                                <MdAccessTime size={18} className="text-muted" />
                                {formatDate(editAppClient.consentAcceptedAt)}
                            </span>
                        </Col>


                        <Col md={6} className="mt-4 pt-3">
                            <div className="d-flex align-items-center gap-2">
                                {editAppClient.profileCompleted ? (
                                    <MdCheckCircle color="#00C896" size={24} title="Completed" />
                                ) : (
                                    <MdCancel color="#dc3545" size={24} title="Not Completed" />
                                )}
                                <span 
                                    className="edit-label mb-0 fw-bold" 
                                    style={{ color: editAppClient.profileCompleted ? "#00C896" : "#dc3545", fontSize: "16px" }}
                                >
                                    Profile {editAppClient.profileCompleted ? "Completed" : "Incomplete"}
                                </span>
                            </div>
                        </Col>

                        {/* --- METADATA & CID DISPLAY --- */}
                        <div className="mt-4 border-top pt-3">
                            <h6 className="text-muted mb-3">System Metadata & History</h6>
                            
                            <Row className="g-3">
                                {/* Current Status */}
                                <Col md={6}>
                                    <div className="mb-4 p-3 rounded h-100" style={{ backgroundColor: "#f8f9fa", border: "1px solid #dee2e6" }}>
                                        <span className="text-muted d-block mb-1" style={{ fontSize: "13px", fontWeight: "600" }}>
                                            Current Status
                                        </span>
                                        <div className="d-flex align-items-center gap-2 fw-bold text-capitalize" 
                                            style={{ fontSize: "16px", color: getStatusDisplay(editAppClient.status).color }}>
                                            {getStatusDisplay(editAppClient.status).icon}
                                            {editAppClient.status || 'Pending'}
                                        </div>
                                    </div>
                                </Col>

                                {/* Linked CID Output Area */}
                                <Col md={6}>
                                    <div className="mb-4 p-3 rounded h-100" style={{ backgroundColor: "#f8f9fa", border: "1px solid #dee2e6" }}>
                                        <span className="text-muted d-block mb-1" style={{ fontSize: "13px", fontWeight: "600" }}>
                                            Linked Client ID (CID)
                                        </span>
                                        <div className="d-flex align-items-center gap-2 fw-bold" style={{ fontSize: "16px", color: "#495057" }}>
                                            <MdPersonOutline size={20} color="#6c757d" />
                                            {/* Renders the specific CID if it exists, otherwise says 'Not Linked' */}
                                            <span>{editAppClient.cid ? editAppClient.cid : 'Not Linked'}</span>
                                        </div>
                                    </div>
                                </Col>
                            </Row>

                            <h6 className="text-muted mb-3" style={{ fontSize: "14px" }}>Action History</h6>
                            <div className="action-history-list">
                                <Row className="g-3 mb-2 pb-2 border-bottom text-muted" style={{ fontSize: "12px", fontWeight: "600" }}>
                                    <Col md={4}>Status</Col>
                                    <Col md={4}>Action At</Col>
                                    <Col md={4}>Action By</Col>
                                </Row>

                                {fullHistoryLog.map((action, index) => (
                                    <Row key={index} className="g-3 mb-2 pb-2 border-bottom align-items-center">
                                        <Col md={4}>
                                            <span className="d-flex align-items-center gap-1 fw-bold text-capitalize" 
                                                style={{ fontSize: "14px", color: getStatusDisplay(action.status).color }}>
                                                {getStatusDisplay(action.status).icon}
                                                {action.status}
                                            </span>
                                        </Col>
                                        <Col md={4}>
                                            <span className="d-flex align-items-center gap-1 fw-bold" style={{ fontSize: "14px", color: "#495057" }}>
                                                <MdAccessTime size={16} className="text-muted" />
                                                {formatDate(action.at)}
                                            </span>
                                        </Col>
                                        <Col md={4}>
                                            <span className="d-flex align-items-center gap-1 fw-bold" style={{ fontSize: "14px", color: "#495057" }}>
                                                <MdPersonOutline size={16} className="text-muted" />
                                                {action.by || 'N/A'}
                                            </span>
                                        </Col>
                                    </Row>
                                ))}
                            </div>
                        </div>  
                    </Row>
                    
                    <div className="edit-modal-footer p-3 border-top">
                        <div className="d-flex w-100 gap-3">
    {user.role === "admin" && (
        <Button 
            variant="danger" 
            type="button" 
            className="flex-fill d-flex align-items-center justify-content-center fw-bold shadow-sm"
            onClick={() => handleStatusChange('rejected')}
            disabled={disableActions} // <--- ADDED THIS
        >
            <MdCancel className="me-2" size={20} /> Reject
        </Button>
    )}
    
    <Button 
        variant="warning" 
        type="button" 
        className="flex-fill d-flex align-items-center justify-content-center fw-bold shadow-sm text-white"
        onClick={() => handleStatusChange('hold')}
        disabled={disableActions} // <--- ADDED THIS
    >
        <MdPauseCircleFilled className="me-2" size={20} /> Hold
    </Button>

    <Button 
        variant="success" 
        type="button" 
        className="flex-fill d-flex align-items-center justify-content-center fw-bold shadow-sm"
        onClick={handleApprove} 
        disabled={disableActions || editAppClient.status === "approved"} // <--- ADDED THIS
    >
        <MdCheckCircle className="me-2" size={20} /> Approve
    </Button>

    
    {/* DYNAMIC EDIT / SAVE BUTTON - Admin Only */}
    {user.role === "admin" && (
        !isEditing ? (
            <Button 
                type="button" 
                className="btn-update-client d-flex align-items-center justify-content-center"
                style={{ backgroundColor: "#0d6efd", color: "#fff", border: "none" }}
                onClick={(e) => {
                    e.preventDefault(); 
                    setIsEditing(true); // <--- This unlocks the disabled buttons!
                }}
            >
                <MdEdit className="me-2" size={18} /> Edit
            </Button>
        ) : (
            <Button 
                type="submit" 
                className="btn-update-client d-flex align-items-center justify-content-center"
                style={{ backgroundColor: "#00C896", color: "#fff", border: "none" }}
            >
                <MdSave className="me-2" size={18} /> Save
            </Button>
        )
    )}
</div>
                    </div>
                </Form>
            </SimpleBar>

            <ApproveClientModal 
                isOpen={isApproveModalOpen}
                onClose={() => setIsApproveModalOpen(false)}
                clientData={editAppClient}
                options={options}
                currentUser={user}
                onConfirm={executeApproval} 
            />
            
        </div>
    )
}